import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { tagMappings as saveTagMapping } from 'utils/urls';

import { TagMappings } from 'types/tagMapping';
import { ErrorModal } from 'types/modalTypes';

export async function postTagMapping({
  AccountId,
  TagMapping,
}: TVariables): Promise<TResult> {
  const response = await fetch(saveTagMapping(AccountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(TagMapping),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  AccountId: number;
  TagMapping: Array<TagMappings>;
};

type TSnapshot = unknown;

function useSaveTagMappings(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const newTagMapping = await postTagMapping(params);
    if (newTagMapping.StatusCode === 200) {
      queryClient.invalidateQueries(['get_tag_mappings']);
      return newTagMapping;
    } else if (newTagMapping.Errors[0].Message) throw newTagMapping;
    return newTagMapping;
  });
}

export { useSaveTagMappings };
